// extracted by mini-css-extract-plugin
export var closeButton = "_kd-1";
export var closeX = "_kd-3";
export var container = "_kd-0";
export var image = "_kd-2";